<template>
    <div id="order-detail">
        <div id="order-detail-header">
            <div class="order-detail-username">
                {{orderStatus}}
            </div>
        </div>

        <div id="order-detail-profile-info">
            <img class="icon" src="../../assets/order_detail_location.png" alt="">
            <div class="address">
                <div class="phone">
                    <div class="username">
                        {{ userName }}
                    </div>
                    <div class="tel">
                        {{ tel }}
                    </div>
                </div>

                <div class="address-info">
                    {{ address }}
                </div>
            </div>
        </div>

        <div id="order-detail-yakult-info">
            <div v-if="!freed" class="price">总价：￥{{ totalPrice }}</div>

            <div class="order-detail-yakult" v-for="(item, index) in goodList" :key="index">
                <img class="icon" :src="item.imageUrl" alt="">
                <div class="number">
                    <div class="title">
                        {{item.goodsName}}
                    </div>

                    <div class="good-number">
                        数量：{{item.count + "*￥" + item.goodsPrice }}
                    </div>
                </div>
            </div>

            <div class="status">
                <div v-if="orderStatus === '未配送' && !isDelivered && !freed && !cancelTextVisible" class="cancel-btn"
                     @click="handleCancel">取消订单
                </div>
                <div v-if="orderStatus === '已配送' " class="cancel-btn" @click="handleFinish">确认收货</div>
                <div>备注：{{ remark }}</div>
                <div v-if="orderStatus === '已取消'">
                    <div>取消理由：{{ cancelReason }}</div>
                    <div>取消端：{{ cancelEnd }}</div>
                </div>
            </div>
        </div>

        <!-- 兑换记录列表 -->
        <div class="record-item" v-for="item in exchangeList" :key="item.id">
            <div class="item-content">
                <div class="item-left">
                    <div class="title-row">
                        <span class="item-title">{{ item.title }}</span>
                        <div class="status-tag" :class="'status-' + item.status">{{ item.statusText }}</div>
                    </div>
                    <span class="item-time">{{ item.time }}</span>
                </div>
                <div class="item-right">
                    <img class="good-icon" :src="item.commodityPicUrl" alt="">
                </div>
            </div>
        </div>

        <div id="order-detail-info">
            <div>订单编号：{{orderNumber}}</div>
            <div>下单时间：{{ orderTime }}</div>
            <div v-if="orderStatus === '已完成'">
                完成配送时间：{{ deliverTime}}
            </div>
            <div v-else-if="orderStatus === '已取消'">
                <div>取消时间：{{statusTime}}</div>

                <div v-if="isDelivered">
                    <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
                        配送中心电话：{{distributionTle}}
                        <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
                    </div>
                </div>
                <div v-else-if="cancelTextVisible">
                    <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
                        配送中心电话：{{distributionTle}}
                        <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
                    </div>
                </div>
                <div v-else>
                    <div>配送中心电话：暂无配送中心信息</div>
                </div>
            </div>
            <div v-else-if="orderStatus === '已配送'">
                完成配送时间： {{deliverTime}}
                <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
                    配送中心电话：{{distributionTle}}
                    <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
                </div>
            </div>
            <div v-if="orderStatus === '未配送' && isDelivered">
                <div>预计配送时间：{{forecastDeliverTime}}</div>
                <div >提示：已为该订单分配益力多姐姐，如要取消订单请联系</div>
                <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
                    配送中心电话：{{distributionTle}}
                    <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
                </div>
            </div>
            <div v-else-if="orderStatus === '未配送'">
                <div v-if="cancelTextVisible">
                    <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
                        配送中心电话：{{distributionTle}}
                        <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
                    </div>
                </div>
                <div v-else>配送中心电话：暂无配送中心信息</div>
            </div>


        </div>
        <div class="back-btn" @click="backBtn">返回</div>

        <base-dialog v-if="messageVisible" :title="title" display="none" width="80%" @close="close">
            <div class="order-cancel-reason">
                <div class="canceled-title">取消订单</div>
                <div style="text-align: left">请选择取消理由</div>
                <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
                    <span class="radio" :class="{'on':item.isChecked}"></span>
                    <input v-model="reason" :value="item.value" class="input-radio" :checked='item.isChecked'  @click="check(index)" type="radio">{{item.label}}
                </div>
                <input class="other-reason" type="text" v-model="otherReason" v-show="isOtherReason"/>
            </div>
            <div class="dialog-cancel" @click="close">取消</div>
            <button class="dialog-ok" @click="requestCancelOrder" :disable="cancelBtnDisable">确定</button>
        </base-dialog>

        <base-dialog v-if="finishedVisible" :title="finishedTitle" display="none" width="80%" @close="close">
            <p style="padding: 1.5rem 0; font-size: 1rem">是否确认收货?</p>
            <div class="dialog-btn" style="float: left;" @click="close">取消</div>
            <button class="dialog-btn" style="float: right;" @click="requestConfirmOrder" :disabled="btnDisable">确定</button>
        </base-dialog>

        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>

    </div>
</template>

<script>
    import {OrderCancel, OrderConfirm, OrderInfo} from "@/api/Orders";
    import {numFilter, parseTime, starPhone} from "@/unitls";
    import BaseDialog from "@/components/BaseDialog";
    import {BASE_URL} from "@/config/app";

    export default {
        name: "OrderDetail",
        components: {BaseDialog},
        data() {
            return {
                id: this.$route.query.orderId,
                orderStatus: this.$route.query.status,
                userName: '',
                tel: '',
                address: '',
                orderNumber: '',
                remark: '',
                cancelReason: '',
                cancelEnd: '',
                orderTime: '',
                statusTime: '',
                deliverTime: '',
                forecastDeliverTime: '',
                distributionTle: '',
                isDelivered: false,
                totalPrice: 0,
                goodList: [],

                title: '取消理由',
                messageVisible: false,
                message: "",

                finishedTitle: '确认收货',
                finishedVisible: false,

              cancelTextVisible: false,


                toastShow: false,
                toastText: '',

                isOrderOk: false,

                reason: '发货太慢',
                otherReason: '',
                isOtherReason: false,

                radios:[
                    {
                        label: '发货太慢',
                        value: '发货太慢',
                        isChecked: true,
                    },
                    {
                        label: '现在不想购买',
                        value: '现在不想购买',
                        isChecked: false,
                    },
                    {
                        label: '重复下单',
                        value: '重复下单',
                        isChecked: false,
                    },
                    {
                        label: '收货人信息有误',
                        value: '收货人信息有误',
                        isChecked: false,
                    },
                    {
                        label: '其他原因',
                        value: '其他原因',
                        isChecked: false,
                    },
                ],

                btnDisable: false,
                cancelBtnDisable: false,

                freed: false,//是否为赠饮订单

                statusMap: {
                    0: '未配送',
                    1: '配送中',
                    2: '已配送'
                },

                exchangeList: [],
            }
        },

        mounted() {
          this.requestOrderDetail();
        },

        methods: {
            //设置取消理由
            check(index) {
                // 先取消所有选中项
                this.radios.forEach((item) => {
                    item.isChecked = false;
                });
                //再设置当前点击项选中
                this.reason = this.radios[index].label;
                if (this.radios[index].value === '其他原因') {
                    this.isOtherReason = true;
                } else {
                    this.isOtherReason = false;
                }
                // 设置值，以供传递
                this.radios[index].isChecked = true;
            },


            close() {
                this.messageVisible = false;
                this.finishedVisible = false;
                this.$emit('close');
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;
                    if (_that.isOrderOk) {
                        _that.$router.go(-1);
                    }
                }, 1500)
            },
            requestOrderDetail(){
                OrderInfo(this.id)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.userName = response.data.consignee;
                            this.tel = starPhone(response.data.mobile);
                            this.address = response.data.area + response.data.address;
                            this.orderNumber = response.data.orderNumber;
                            this.remark = response.data.remark;
                            this.cancelReason = response.data.orderCancelReason;
                            this.statusTime = parseTime(response.data.cancelledAt);
                            this.deliverTime = parseTime(response.data.deliveredAt);
                            this.forecastDeliverTime = response.data.forecastDeliverTime;
                            this.orderTime = parseTime(response.data.createdAt);
                            this.cancelEnd = this.formatStatus(response.data.orderCancelClient);
                            this.freed = response.data.freed;

                            if (response.data.deliverStatus == 2) {
                                this.isDelivered = true;
                                this.distributionTle = response.data.distributionCenterTel;
                            }
                            this.totalPrice = numFilter(response.data.totalPrice);

                            // 处理兑换记录列表
                            let exchangeList = [];
                            if (response.data.stampShopVoucherList && response.data.stampShopVoucherList.length > 0) {
                                response.data.stampShopVoucherList.forEach(item => {
                                    exchangeList.push({
                                        id: item.id,
                                        title: item.awardName ? `${item.activityName}：${item.awardName || ''}(${item.duiName || ''})` : item.activityName + '：' +item.duiName,
                                        time: item.writeOffTime ? parseTime(item.writeOffTime) : '',
                                        status: item.status !== undefined ? item.status : 0,
                                        statusText: this.statusMap[item.status !== undefined ? item.status : 0],
                                        commodityPicUrl: BASE_URL + item.duiImgUrl
                                    });
                                });
                            }
                            this.exchangeList = exchangeList;

                            response.data.goodsList.forEach((item) => {

                              if (item.name === '益力多青提味20瓶' &&  item.number > 0) {
                                this.cancelTextVisible = true;
                                this.distributionTle = response.data.distributionCenterTel;
                              }
                              if (item.number > 0) {
                                this.goodList.push({
                                  id: item.goodsId,
                                  goodsName: item.name,
                                  count: item.number,
                                  goodsPrice: item.price,
                                  imageUrl: BASE_URL + item.imageUrl
                                });
                              }
                            });
                        }
                    })
            },

            handleCancel(){
                this.messageVisible = true;
            },
            handleFinish() {
                this.finishedVisible = true;
            },
            requestCancelOrder() {
                let orderCancelReason = '';

                if (this.reason === '其他原因') {
                    orderCancelReason = this.otherReason
                } else {
                    orderCancelReason = this.reason
                }
                this.cancelBtnDisable = true;
                OrderCancel(this.id, orderCancelReason)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.messageVisible = false;
                            this.toast('订单取消成功');
                            this.$emit('close');
                            this.isOrderOk = true;
                        } else {
                            this.messageVisible = false;
                            this.toast(response.message);
                            this.cancelBtnDisable = false;
                        }

                    })
            },

            requestConfirmOrder() {
                this.btnDisable = true;
                OrderConfirm(this.id)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.finishedVisible = false;
                            this.toast('收货成功');
                            this.$emit('close');
                            this.isOrderOk = true;
                        } else {
                            this.finishedVisible = false;
                            this.toast(response.message);
                            this.btnDisable = false;
                        }

                    })
            },

            formatStatus(value) {
                return value === this.$ORDERS_CANCEL.MEMBER ? '用户端' : value === this.$ORDERS_CANCEL.LADY ? '益力多姐姐端' : value === this.$ORDERS_CANCEL.DISTRIBUTION_CENTER ? '配送中心端'  :  '用户端';

            },

            callPhone(tel) {
                window.location.href = 'tel://' + tel;
            },

            backBtn() {
                this.$router.go(-1);
            }
        },
    }
</script>

<style scoped lang="scss">

    *{
        margin: 0;
        padding: 0;
    }

    #order-detail {
        background: #fdf9f7;
        width: auto;
        height: auto;
        overflow-y:auto;
        top: 0;
        left: 0;
        padding-bottom: 60px;
        //header
        #order-detail-header {
            width: auto;
            height: 6rem;
            background: url("../../assets/detail.png");
            background-size: 100% 6rem;

            .order-detail-icon {
                width: 39px;
                height: 57px;
                float: left;
                margin-left: 30px;
                line-height: 6rem;
            }

            .order-detail-username {
                float: right;
                line-height: 6rem;
                margin-right: 30px;
                color: white;
                font-size: 1rem;
                font-weight: bold;
            }
        }

        //个人详细信息
        #order-detail-profile-info {
            height: 80px;
            padding-top: 15px;
            padding-right: 10px;
            text-align: center;
            background: #FFFFFF;
            //定位图标
            .icon {
                float: left;
                margin-top: 8px;
                margin-left: 20px;
            }

            //用户信息及详细地址
            .address {
                .phone {
                    .username {
                        font-size: 0.8rem;
                        margin-left: 15px;
                        float: left;
                    }

                    .tel {
                        font-size: 0.9rem;
                        text-align: left;
                        text-indent: 4em;
                    }
                }

                .address-info {
                    font-size: 0.8rem;
                    text-align: left;
                    margin-left: 50px;
                }
            }


        }

        .order-detail-yakult{
            height: 120px;
        }

        #order-detail-yakult-info {
            margin-top: 20px;
            background: #FFFFFF;
            padding-top: 10px;
            padding-bottom: 10px;

            .price {
                text-align: right;
                margin-right: 20px;
                color: #ea2d53;
            }

            .icon {
                width: 80px;
                height: 80px;
                margin-left: 30px;
                float: left;
            }

            .number {
                text-align: left;
                line-height: 40px;
                text-indent: 2em;

                .title {
                    color: #ea2d53;
                    font-size: 1.1rem;
                }

                .good-number {
                    font-size: 0.9rem;
                }
            }

            .status {
                text-align: left;
                margin-top: 20px;
                margin-left: 30px;
                font-size: 0.9rem;

                .cancel-btn {
                    float: right;
                    margin-right: 10px;
                    padding: 5px 10px;
                    color: #ea2d53;
                    border: 1px solid #ea2d53;
                    border-radius: 5px;
                    font-size: 0.9rem;
                    margin-top: -10px;
                }
            }
        }

        // 兑换记录列表样式
        .record-item {
            background-color: #fff;
            border-radius: 8px;
            margin-top: 10px;
            margin-bottom: 10px;
            padding: 15px;
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
        }

        .item-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 43px;
        }

        .item-left {
            flex: 1;
            margin-right: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .title-row {
            text-align: left;
            display: flex;
            align-items: center;
            margin-bottom: 6px;
        }

        .item-title {
            display: block;
            font-size: 15px;
            color: #333;
            font-weight: 500;
            line-height: 1.4;
            flex: 1;
        }

        .status-tag {
            font-size: 10px;
            padding: 2px 6px;
            border-radius: 4px;
            white-space: nowrap;
            display: inline-block;
            margin-left: 6px;
            font-weight: 400;
        }

        .status-tag.status-0 {
            background-color: rgba(255, 152, 0, 0.1);
            color: #ff9800;
        }

        .status-tag.status-1 {
            background-color: rgba(33, 150, 243, 0.1);
            color: #2196f3;
        }

        .status-tag.status-2 {
            background-color: rgba(76, 175, 80, 0.1);
            color: #4caf50;
        }

        .item-time {
            display: block;
            font-size: 13px;
            color: #999;
            line-height: 1.4;
        }

        .item-right {
            display: flex;
            align-items: center;
            flex-shrink: 0;
        }

        .good-icon {
            width: 60px;
            height: 60px;
            border-radius: 6px;
            border: 1px solid #eee;
            background-color: #f5f5f5;
            object-fit: cover;
        }

        #order-detail-info {
            padding-top: 10px;
            margin-top: 20px;
            padding-left: 30px;
            margin-bottom: 20px;
            padding-bottom: 10px;
            background: #FFFFFF;
            text-align: left;
            font-size: 0.9rem;
            line-height: 25px;
        }

        .clear {
            clear: both;
        }

        .order-cancel-reason {
            text-align: left;
            margin-bottom: 10px;

            .canceled-title {
                color: #ea2d53;
                text-align: center;
                font-size: 1rem;
                font-weight: bold;
                padding: 5px 0;
            }

            .cancel-radio {
                line-height: 30px;
            }

            .other-reason {
                border: 1px solid #495060;
                width: 100%;
                padding: 10px;
                height: 50px;
                border-radius: 5px;
                margin-bottom: 10px;
            }

            .radio-box{
                display: inline-block;
                position: relative;
                height: 25px;
                line-height: 25px;
                width: 50%;
                text-align: left;
                margin: 5px 0;
            }

            .input-radio {
                display: inline-block;
                position: absolute;
                opacity: 0;
                width: 100%;
                height: 25px;
                left: 0px;
                outline: none;
                -webkit-appearance: none;
            }
            .radio {
                display: inline-block;
                width: 22px;
                height: 22px;
                vertical-align: middle;
                background-image: url(../../assets/checkbox_off.png);
                background-repeat: no-repeat;
                //background-position: 0 0;
                background-size: 100% 100%;
                margin-top: -5px;
                margin-right: 5px;
            }
            .on {
                width: 22px;
                height: 22px;
                background-image: url(../../assets/checkbox_on.png);
                background-size: 100% 100%;
            }
        }

        .dialog-ok {
            float: right;
            width: 45%;
            color: #ffffff;
            padding: 10px 0;
            background: #ea2d53;
            border-radius: 5px;
            border: none;
        }

        .dialog-cancel {
            float: left;
            width: 45%;
            color: #ffffff;
            padding: 10px 0;
            background: #ea2d53;
            border-radius: 5px;
        }

        .back-btn {
            margin: auto;
            width: 80%;
            font-size: 1rem;
            font-weight: bold;
            color: #ea2d53;
            border: 1px solid #ea2d53;
            border-radius: 5px;
            padding: 10px;
        }
    }

    .dialog-btn {
        /*float: left;*/
        width: 45%;
        color: #ffffff;
        padding: 10px 0;
        background: #ea2d53;
        border-radius: 5px;
        border: none;
    }

    @media screen and (max-width: 320px){
        #order-detail {

            .order-cancel-reason {
                text-align: left;
                margin-bottom: 10px;


                .radio-box{
                    display: inline-block;
                    position: relative;
                    height: 25px;
                    line-height: 25px;
                    width: 100%;
                    text-align: left;
                    margin: 5px 0;
                }
            }


        }
    }

</style>
